import api from '@api';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
    getOrderMessagesOnExpeditionBoxGridFetchSuccess,
    getOrderMessagesOnExpeditionBoxGridFetchFailure,
} from './reducer';
import { GridRequestType } from 'src/types/table';
import { RootStoreType } from 'src/types/store';
import { OrderMessagesOnExpeditionBoxGridResType } from 'src/types/orderMessagesOnExpeditionBoxGrid';

export const ORDER_MESSAGE_ON_EXPEDITION_BOX_GRID_URL = 'api/secure/messages-on-expedition-box/grid';

export interface GetOrderExpeditionPackageGridCallPayloadType {
    params: GridRequestType;
}

const getOrderMessagesOnExpeditionBoxGridFetchRequest = async (
    payload: GetOrderExpeditionPackageGridCallPayloadType
) => {
    const res = await api('post', ORDER_MESSAGE_ON_EXPEDITION_BOX_GRID_URL, payload.params);
    return res.data.data;
};

function* getOrderMessagesOnExpeditionBoxGridFetch(action: {
    type: string;
    payload?: GetOrderExpeditionPackageGridCallPayloadType;
}) {
    try {
        let payloadData: GetOrderExpeditionPackageGridCallPayloadType | undefined = action.payload;
        if (!payloadData) {
            const params: GridRequestType = yield select(
                (state: RootStoreType) => state.orderMessagesOnExpeditionBoxGrid.data?.request
            );
            if (params) {
                payloadData = {
                    params,
                };
            }
        }
        if (payloadData) {
            const response: OrderMessagesOnExpeditionBoxGridResType = yield call((): any =>
                // @ts-ignore
                getOrderMessagesOnExpeditionBoxGridFetchRequest(payloadData)
            );
            yield put(getOrderMessagesOnExpeditionBoxGridFetchSuccess(response));
        } else {
            yield put(getOrderMessagesOnExpeditionBoxGridFetchFailure({ error: null }));
        }
    } catch (error) {
        yield put(getOrderMessagesOnExpeditionBoxGridFetchFailure({ error }));
    }
}

export function* getOrderMessagesOnExpeditionBoxGridFetchWatch() {
    yield takeEvery(
        'orderMessagesOnExpeditionBoxGrid/getOrderMessagesOnExpeditionBoxGridFetch',
        getOrderMessagesOnExpeditionBoxGridFetch
    );
}
